import { Selection } from "./Selection";
export class TreeSelection extends Selection {
    constructor() {
        super(...arguments);
        this._clickToExpand = 0;
    }
    get clickToExpand() {
        return this._clickToExpand;
    }
    set clickToExpand(value) {
        this._clickToExpand = value;
    }
    getSelectedNode() {
        let i = this.index;
        if (i != -1)
            return this._owner.getChildAt(i).treeNode;
        else
            return null;
    }
    getSelectedNodes(out) {
        if (!out)
            out = [];
        s_list.length = 0;
        this.get(s_list);
        let cnt = s_list.length;
        let ret = [];
        for (let i = 0; i < cnt; i++) {
            let node = this._owner.getChildAt(s_list[i]).treeNode;
            ret.push(node);
        }
        return ret;
    }
    selectNode(node, scrollItToView) {
        let parentNode = node.parent;
        while (parentNode && parentNode != this._owner.rootNode) {
            parentNode.expanded = true;
            parentNode = parentNode.parent;
        }
        if (!node.cell)
            return;
        this.add(this._owner.getChildIndex(node.cell), scrollItToView);
    }
    unselectNode(node) {
        if (!node.cell)
            return;
        this.remove(this._owner.getChildIndex(node.cell));
    }
    handleClick(item, evt) {
        let scroller = this._owner.scroller;
        if (scroller === null || scroller === void 0 ? void 0 : scroller.isDragged)
            return;
        if (evt.button == 2 && !this.allowSelectByRightClick)
            return;
        if (this._clickToExpand != 0) {
            let node = item.treeNode;
            if (node && node.isFolder && this._expandedStatusInEvt == node.expanded) {
                if (this._clickToExpand == 2) {
                    if (evt.isDblClick)
                        node._setExpanded(!node.expanded, true);
                }
                else
                    node._setExpanded(!node.expanded, true);
            }
        }
        super.handleClick(item, evt);
    }
    handleArrowKey(dir, evt) {
        if (dir == 3 || dir == 7) {
            let i = this.index;
            if (i != -1) {
                let node = this._owner.getChildAt(i).treeNode;
                if (node.isFolder) {
                    node.expanded = dir == 3;
                    return i;
                }
            }
        }
        return super.handleArrowKey(dir, evt);
    }
}
var s_list = [];
